// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TextBlock_wrapper__3XCcA","title":"TextBlock_title__54IGd","inView":"TextBlock_inView__2OoBz","content":"TextBlock_content__A9yJA","cta":"TextBlock_cta__3ny9G"};